import DatePickerSelector from './index.vue'

DatePickerSelector.install = function (Vue) {
	Vue.component(DatePickerSelector.name, DatePickerSelector);
}

export default DatePickerSelector;